// Google Maps JavaScript API key — the same key used by the Reebakaanya mobile apps,
// with Maps JavaScript API + Places API enabled and this site added to its
// restrictions. Restriction is what protects it, not secrecy — a client-side Maps key
// is always visible in the bundled JS.
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDEYaZllJMqufD-s6H9odMkZiu-qiS5rsQ';
